import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { sessionStateService } from '@logz-pkg/frontend-services';
import { useNewApplicationState } from '../../hooks/new-application-state.hook';
import { getIsNewAccount } from 'ui/hooks/queries/useIsNewAccount';
import { queryClient } from 'ui/components/AppProvider/AppProvider';
import { featureFlagStateService } from 'ui/state/feature-flag.state.service';

const queryFn = async () => {
  if (isEmpty(sessionStateService.session.get())) {
    await sessionStateService.fetch();
  }

  const isNewAccount = await getIsNewAccount();
  const newAppState = await useNewApplicationState.get(queryClient);
  const isNewAppRouterFFEnabled = featureFlagStateService.isFeatureEnabled('NewAppRouter');
  const isNewAppToggleEnabled = featureFlagStateService.isFeatureEnabled('NewAppToggle');

  const isEnabled = isNewAccount || isNewAppRouterFFEnabled || (isNewAppToggleEnabled && newAppState?.enabled);
  const isAllowedOnOldApp = !isNewAppRouterFFEnabled && !isNewAccount;

  return { isEnabled, isNewAccount, isAllowedOnOldApp };
};

const useIsNewAppEnabledQuery = () => {
  return useQuery({
    queryKey: ['is-new-app-enabled'],
    queryFn,
  });
};

export const getIsNewAppEnabled = () => {
  return queryClient.ensureQueryData({
    queryKey: ['is-new-app-enabled'],
    queryFn,
  });
};

export const useIsNewAppEnabled = () => {
  const { data: { isEnabled: isNewAppEnabled, isNewAccount } = {}, isFetched: isFetchedNewAppEnabled } =
    useIsNewAppEnabledQuery();

  return {
    isNewAppEnabled,
    isFetched: isFetchedNewAppEnabled || (!isNewAccount && isNewAppEnabled !== undefined),
  };
};
